import {
  FlexBox,
  H2,
  H3,
  Link,
  Typography,
  Callout,
  ModalDialog,
  ModalDialogBody,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogNav,
} from "@vp/swan";
import React, { useState } from "react";
import {
  PluginExperimentContext,
  PluginOwner,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import { useExperimentsContext } from "../../contexts/ExperimentsProvider";

export interface DebugPluginComponentProps extends React.PropsWithChildren {
  componentName: string;
  contactInfo: PluginOwner;
  experimentContext?: PluginExperimentContext;
}

export const DebugPluginComponent: React.FC<DebugPluginComponentProps> = props => {
  const { children, componentName, contactInfo, experimentContext } = props;
  const { ownerName, slack, issueEscalation } = contactInfo;
  const { useExperiment } = useExperimentsContext();
  const variationKey = experimentContext && useExperiment(experimentContext);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const detailFlyout = (
    <ModalDialog
      isOpen={isDialogOpen}
      onRequestDismiss={() => {
        setIsDialogOpen(false);
      }}
      variant="panel-right"
    >
      <ModalDialogContent>
        <ModalDialogNav>
          <ModalDialogCloseButton />
        </ModalDialogNav>
        <ModalDialogBody>
          <FlexBox flexDirection={"column"}>
            <H2 fontSize={"small"} mr={"3"}>
              {`Debug: plugin component - ${componentName}`}
            </H2>
            {experimentContext ? (
              <FlexBox flexDirection={"column"}>
                <H3 fontSize={"xsmall"}>Experiment Context:</H3>
                <Typography
                  fontSize={"xsmall"}
                >{`Experiment Key: ${experimentContext.experimentKey}`}</Typography>
                <Typography
                  fontSize={"xsmall"}
                >{`Experiment Variation: ${variationKey}`}</Typography>
              </FlexBox>
            ) : (
              <></>
            )}
          </FlexBox>
        </ModalDialogBody>
      </ModalDialogContent>
    </ModalDialog>
  );

  return (
    <div className="debug-plugin-container">
      <FlexBox justifyContent={"space-between"}>
        <FlexBox className="debug-plugin-info" alignItems={"center"}>
          <Typography fontSize={"xsmall"}>
            {componentName} - {ownerName}
          </Typography>
          {slack && (
            <Link href={slack} ml={"3"}>
              <Typography fontSize={"xsmall"}>Slack</Typography>
            </Link>
          )}
          {issueEscalation && (
            <Link href={issueEscalation} ml={"3"}>
              <Typography fontSize={"xsmall"}>Urgent Issue</Typography>
            </Link>
          )}
        </FlexBox>
        <FlexBox
          className={"debug-plugin-status-bar"}
          onClick={() => setIsDialogOpen(!isDialogOpen)}
        >
          {experimentContext ? (
            <Callout size="mini" variant="inverse" skin="holiday">
              AB
            </Callout>
          ) : (
            <></>
          )}
        </FlexBox>
      </FlexBox>
      {detailFlyout}
      {children}
    </div>
  );
};
